const swiperEl = document.querySelector(".heroSwiper");

if (swiperEl) {
  const autoplayEnabled = swiperEl.dataset.autoplay === "true";
  const delay = parseInt(swiperEl.dataset.delay);
  const speed = parseInt(swiperEl.dataset.speed);

  new Swiper(swiperEl, {
    loop: false,
    speed: speed,
    autoplay: autoplayEnabled
      ? {
          delay: delay,
          disableOnInteraction: false
        }
      : false,
    pagination: {
      el: swiperEl.querySelector(".swiper-pagination"),
      clickable: true
    }
  });
}